"use client";

import { MessageChannel } from "@prisma/client";
import { createContext, ReactNode, useContext } from "react";
import { CallPeriod } from "@/app/types/call/CallPeriod";
import { WorkspaceSelection } from "@/app/types/common/WorkspaceSelection";

const DEFAULT_SELECTION: WorkspaceSelection = {
  channel: MessageChannel.LINKEDIN,
  period: CallPeriod.ALL,
  periodRange: {},
};

const SelectionContext = createContext<WorkspaceSelection>(DEFAULT_SELECTION);

type Props = {
  selection: WorkspaceSelection;
  children: ReactNode;
};

export default function SelectionProvider(props: Props) {
  const { selection, children } = props;

  return <SelectionContext.Provider value={selection}>{children}</SelectionContext.Provider>;
}

export function useInitialSelection(): WorkspaceSelection {
  return useContext(SelectionContext);
}
